import { BannerType } from '@generated/graphql';

export const BANNER_SEVERITY: {
  [key in BannerType]: 'info' | 'success' | 'warning' | 'error';
} = {
  [BannerType.Info]: 'info',
  [BannerType.Success]: 'success',
  [BannerType.Urgent]: 'error',
  [BannerType.Warning]: 'warning',
};

const BANNER_TYPE_ORDER = [
  BannerType.Urgent,
  BannerType.Warning,
  BannerType.Success,
  BannerType.Info,
] as const satisfies readonly BannerType[];

type SortableBannerInteraction = {
  alertBanner: {
    bannerType?: BannerType | null;
    createdAt: string;
  };
};

export const sortBannerInteractionsByType = <
  T extends SortableBannerInteraction,
>(
  bannerInteractions: T[],
) => {
  const grouped = Map.groupBy(
    bannerInteractions,
    (interaction) => interaction.alertBanner.bannerType,
  );

  return BANNER_TYPE_ORDER.flatMap((bannerType) =>
    [...(grouped.get(bannerType) ?? [])].sort((a, b) =>
      a.alertBanner.createdAt.localeCompare(b.alertBanner.createdAt),
    ),
  );
};
